import axios from 'axios'
import { TypeConfig, TypeTheme, defaultConfig, defaultTheme, defaultThemeB } from './style/theme'
import { UserApiPartnerConfig } from '@types'
import { replaceNullWithObject } from './util/default'

export const BASE_CLOUD_FRONT_CONFIG_URL =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://d1q0unbpd3pyns.cloudfront.net'
    : process.env.REACT_APP_ENV === 'stage'
    ? 'https://d2l8gjzronllm0.cloudfront.net'
    : 'https://dl27gtzv7mq2q.cloudfront.net'

export const BASE_PARTNER_URL =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://dev.api-user.sauceflex.com'
    : process.env.REACT_APP_ENV === 'stage'
    ? 'https://stage.api-user.sauceflex.com'
    : 'https://api-user.sauceflex.com'

/*
 * @name 파트너 config 로더
 */
async function preLoader(partnerId: string) {
  try {
    const res = await axios.get<UserApiPartnerConfig>(
      `${BASE_CLOUD_FRONT_CONFIG_URL}/config/${partnerId}/broadcast.json`,
    )

    const { airbridge, alarm, collect, guestLogin, marketingGTM, redirection } = res.data.data

    const collectConfig = {
      ...(collect?.config ?? {}),
      airbridge,
      alarm,
      guestLogin,
      isProductPriceVisible: collect.config?.isProductPriceVisible,
      marketingGTM,
      redirection,
      sauceclip: collect?.sauceclip,
    }

    const collectTheme = {
      ...(collect?.theme ?? {}),
    }
    const collectThemeB = {
      ...(collect?.themeB ?? {}),
    }

    const replaceConfig = replaceNullWithObject(
      collectConfig,
      defaultConfig as typeof collectConfig,
    ) as TypeConfig

    const replaceTheme = replaceNullWithObject(
      collectTheme,
      defaultTheme as typeof collectTheme,
    ) as TypeTheme

    const replaceThemeB = replaceNullWithObject(
      collectThemeB,
      defaultThemeB as typeof collectTheme,
    ) as TypeTheme

    return {
      config: replaceConfig,
      theme: replaceTheme,
      themeB: replaceThemeB,
    }
  } catch (err) {
    console.log(err)
    return { config: defaultConfig, theme: defaultTheme, themeB: defaultThemeB }
  }
}

export default preLoader
